import { render } from "./PurchaseOrders.vue?vue&type=template&id=57ed8bf0"
import script from "./PurchaseOrders.vue?vue&type=script&lang=js"
export * from "./PurchaseOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__